/** Albazar.az əlaqə və dəstək məlumatları — bir mərkəzdən idarə olunur. */
export const CONTACT = {
  phone: "+994776030335",
  phoneLabel: "077 603 03 35",
  email: "info@albazar.az",
  adsEmail: "reklam@albazar.az",
  whatsapp: "994776030335",
  address: "Bakı, Nizami küç. 203",
  mapQuery: "Nizami küçəsi 203, Bakı, Azərbaycan",
} as const;

export const telLink = `tel:${CONTACT.phone}`;
export const mailLink = `mailto:${CONTACT.email}`;
export const adsMailLink = `mailto:${CONTACT.adsEmail}?subject=${encodeURIComponent("Reklam yerləşdirmək istəyirəm")}`;

export const waLink = (text: string) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;

export const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT.mapQuery)}`;
export const mapEmbed = `https://maps.google.com/maps?q=${encodeURIComponent(CONTACT.mapQuery)}&z=15&output=embed`;

/** İş saatları — indeks 0 = Bazar ertəsi (həftənin bütün günləri 09:00–22:00). */
export const WORK_HOURS = [
  { day: "Bazar ertəsi", hours: "09:00 — 22:00" },
  { day: "Çərşənbə axşamı", hours: "09:00 — 22:00" },
  { day: "Çərşənbə", hours: "09:00 — 22:00" },
  { day: "Cümə axşamı", hours: "09:00 — 22:00" },
  { day: "Cümə", hours: "09:00 — 22:00" },
  { day: "Şənbə", hours: "09:00 — 22:00" },
  { day: "Bazar", hours: "09:00 — 22:00" },
] as const;

/** Verilən vaxtı Azərbaycan saat qurşağına (Asia/Baku) çevirir. */
function bakuDate(date = new Date()): Date {
  return new Date(date.toLocaleString("en-US", { timeZone: "Asia/Baku" }));
}

/** Cari günün indeksini qaytarır (0 = Bazar ertəsi) — Asia/Baku üzrə. */
export const todayIndex = (date = new Date()): number => (bakuDate(date).getDay() + 6) % 7;

/** İş saatlarında (09:00–22:00, Asia/Baku) olub-olmadığını yoxlayır. */
export const isOpenNow = (date = new Date()): boolean => {
  const baku = bakuDate(date);
  const m = baku.getHours() * 60 + baku.getMinutes();
  return m >= 540 && m < 1320; // 09:00 = 540, 22:00 = 1320
};

/** Açıq/bağlı status mətnini emoji ilə qaytarır. */
export const openStatusLabel = (date = new Date()): string =>
  isOpenNow(date) ? "🟢 İndi açıqdır" : "🔴 İndi bağlıdır";

export const FAQ: { q: string; a: string }[] = [
  {
    q: "Elan yerləşdirmək pulludurmu?",
    a: "Xeyr, adi elanların yerləşdirilməsi tamamilə pulsuzdur. Yalnız VIP və Premium paketlər ödənişlidir.",
  },
  {
    q: "VIP və Premium paketlərin qiyməti nə qədərdir?",
    a: "VIP: 1 gün — 1 AZN, 7 gün — 5 AZN, 30 gün — 20 AZN. Premium: 1 gün — 2 AZN, 7 gün — 10 AZN, 30 gün — 30 AZN.",
  },
  {
    q: "Balansımı necə artıra bilərəm?",
    a: "Balans bölməsindən WhatsApp dəstək xəttinə yazın, ödənişi təsdiqlədikdən sonra məbləğ hesabınıza əlavə olunur.",
  },
  {
    q: "Elanım niyə dərc olunmur?",
    a: "Bütün elanlar moderasiyadan keçir. Qaydalara uyğun olmayan elanlar imtina edilir və səbəbi «Elanlarım» bölməsində göstərilir.",
  },
  {
    q: "Elanı necə redaktə və ya silə bilərəm?",
    a: "Profil menyusundan «Elanlarım» bölməsinə keçin, elanın yanındakı redaktə və ya silmə düyməsini seçin.",
  },
  {
    q: "Şifrəmi unutmuşam, nə etməliyəm?",
    a: "Giriş səhifəsindəki «Şifrəni unutdum» düyməsinə basın — dəstək xidməti WhatsApp vasitəsilə sizə kömək edəcək.",
  },
  {
    q: "Saxta elan və ya dələduzluqla qarşılaşsam?",
    a: "Dərhal elanı şikayət edin və ya WhatsApp dəstək xəttinə yazın. Belə elanlar yoxlanılaraq silinir.",
  },
  {
    q: "Mağaza hesabı necə açılır?",
    a: "Ana səhifədəki mağaza bölməsindən müraciət edin və ya WhatsApp ilə yazın — rəsmi mağaza statusu admin tərəfindən verilir.",
  },
];
